export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14093.d637c839.jpg";